import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

// Template138: Día 5 - Deoksugung y City Hall
const Template138 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const introText = page?.texts?.[1]?.content;
	const heroTitle = page?.texts?.[2]?.content;
	const observatoryTitle = page?.texts?.[3]?.content;
	const observatoryDesc = page?.texts?.[4]?.content;
	const sabiasQueObservatory = page?.texts?.[5]?.content;
	const deoksugungTitle = page?.texts?.[6]?.content;
	const deoksugungDesc = page?.texts?.[7]?.content;
	const sabiasQueGuardia = page?.texts?.[8]?.content;
	const sabiasQueOccidental = page?.texts?.[9]?.content;
	const cityhallTitle = page?.texts?.[10]?.content;
	const cityhallDesc = page?.texts?.[11]?.content;
	const comoLlegarTitle = page?.texts?.[12]?.content;
	const comoLlegarText = page?.texts?.[13]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const deoksugungImage = getImageSrc("deoksugung");
	const cityHallImage = getImageSrc("cityhall");
	const observatorySticker = getCanvasImageUrl("observatory-sticker");
	const logoImage = getCanvasImageUrl("logo");

	const actualHeaderColor = headerBackgroundColor || "#2E8B80";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{(portadaImage || heroTitle || observatorySticker) && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					{portadaImage && (
						<img
							src={portadaImage}
							alt=""
							style={{ width: "100%", height: 200, objectFit: "cover" }}
						/>
					)}
					{observatorySticker && (
						<img
							src={observatorySticker}
							alt=""
							style={{
								width: isSmallScreen ? 100 : 100,
								position: "absolute",
								bottom: 50,
								left: isSmallScreen ? 20 : 20,
							}}
						/>
					)}
					{heroTitle && (
						<Box
							component="h1"
							sx={{
								fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
								fontSize: "32px",
								textAlign: "center",
								position: "absolute",
								bottom: "0",
								margin: "10px",
								left: "20px",
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{heroTitle}
						</Box>
					)}
				</Box>
			)}

			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
					<Box component="p" sx={p}>
						{introText}
					</Box>
				</Box>
			)}

			<Box sx={{ padding: "0 12px 12px" }}>
				{(observatoryTitle || observatoryDesc) && (
					<Box
						data-block-id="text-2"
						sx={{
							backgroundColor: "#caeae6",
							padding: "12px",
							borderRadius: "12px",
							display: "flex",
							gap: "16px",
							alignItems: "center",
							position: "relative",
							marginBottom: "16px",
							marginTop: isSmallScreen ? "10px" : 0,
						}}
					>
						<Box sx={{ paddingLeft: "8px" }}>
							{observatoryTitle && (
								<Box component="h3" sx={h3}>
									{observatoryTitle}
								</Box>
							)}
							{observatoryDesc && (
								<Box component="p" sx={p}>
									{observatoryDesc}
								</Box>
							)}
						</Box>
						{sabiasQueObservatory && (
							<Box
								sx={{
									position: "absolute",
									top: isSmallScreen ? -20 : -12,
									right: "50%",
								}}
							>
								<SabiasQue icono="👀" texto={sabiasQueObservatory} />
							</Box>
						)}
					</Box>
				)}

				{(deoksugungTitle || deoksugungDesc || deoksugungImage) && (
					<Box
						data-block-id="text-3"
						sx={{
							display: "flex",
							gap: "16px",
							position: "relative",
							marginBottom: "16px",
						}}
					>
						{deoksugungImage && (
							<img
								src={deoksugungImage}
								alt=""
								style={{
									width: "40%",
									height: 110,
									objectFit: "cover",
									borderRadius: 12,
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							{deoksugungTitle && (
								<Box component="h3" sx={h3}>
									{deoksugungTitle}
								</Box>
							)}
							{deoksugungDesc && (
								<Box component="p" sx={p}>
									{deoksugungDesc}
								</Box>
							)}
						</Box>
						{sabiasQueGuardia && (
							<Box sx={{ position: "absolute", top: 0, left: "33%" }}>
								<SabiasQue icono="🏯" texto={sabiasQueGuardia} />
							</Box>
						)}
						{sabiasQueOccidental && (
							<Box sx={{ position: "absolute", top: 40, left: "33%" }}>
								<SabiasQue icono="🏛️" texto={sabiasQueOccidental} />
							</Box>
						)}
					</Box>
				)}

				{(cityhallTitle || cityhallDesc || cityHallImage) && (
					<Box
						data-block-id="text-4"
						sx={{
							display: "flex",
							gap: "16px",
							position: "relative",
							marginBottom: "16px",
						}}
					>
						{cityHallImage && (
							<img
								src={cityHallImage}
								alt=""
								style={{
									width: "40%",
									height: 110,
									objectFit: "cover",
									borderRadius: 12,
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							{cityhallTitle && (
								<Box component="h3" sx={h3}>
									{cityhallTitle}
								</Box>
							)}
							{cityhallDesc && (
								<Box component="p" sx={p}>
									{cityhallDesc}
								</Box>
							)}
						</Box>
					</Box>
				)}

				{(comoLlegarTitle || comoLlegarText) && (
					<Box
						data-block-id="text-5"
						sx={{
							backgroundColor: "#caeae6",
							border: "3px solid #2e8b80",
							borderRadius: "12px",
							padding: "8px 20px",
							fontSize: 12,
							fontFamily: "'Poppins', sans-serif",
							color: "#333",
							width: "100%",
						}}
					>
						{comoLlegarTitle && (
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: "8px",
									fontSize: 13,
									fontWeight: 700,
									display: "flex",
									alignItems: "center",
									gap: 6,
									color: "#2e8b80",
									textTransform: "uppercase",
								}}
							>
								{comoLlegarTitle}
							</Box>
						)}
						{comoLlegarText && (
							<Box
								component="p"
								sx={{ margin: 0 }}
								dangerouslySetInnerHTML={{ __html: comoLlegarText }}
							/>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template138.thumbnail = "/images/template-1.png";

export default Template138;
